import TokenService from "@/helpers/token";
import {userPositions} from "@/helpers/constants";

export function getContactAttribute() {
  const resultOrg = [
    {
      name: 'code',
      title: 'Mã khách hàng',
      value: true
    },
    {
      name: 'childFullName',
      title: 'Tên con',
      value: true
    },
    {
      name: 'mobile',
      title: 'Số điện thoại',
      value: true,
      alwayShow: true,
    },
    {
      name: 'birthday',
      title: 'Năm sinh',
      value: true
    },
    {
      name: 'birthdayDescription',
      title: 'Độ tuổi',
      value: true
    },
    {
      name: 'productDescription',
      title: 'Khoá học đăng ký',
      value: true
    },
    {
      name: 'capability',
      title: 'Học lực',
      value: true
    },
    {
      name: 'studyResult',
      title: 'Kết quả học tập',
      value: false
    },
    {
      name: 'email',
      title: 'Email',
      value: true
    },
    {
      name: 'parentFullName',
      title: 'Tên phụ huynh',
      value: true
    },
    {
      name: 'numberOfCall',
      title: 'Số lần gọi kho T',
      value: false
    },
    {
      name: 'numberOfCallC',
      title: 'Số lần gọi kho C',
      value: false
    },
    // {
    //   name: 'numberOfCallG',
    //   title: 'Số lần gọi G',
    //   value: false
    // },
    {
      name: 'detailAddress',
      title: 'Địa chỉ chi tiết',
      value: true
    },
    {
      name: 'contactSources',
      title: 'Nguồn khách hàng',
      value: true
    },
    {
      name: 'user',
      title: 'Người phụ trách',
      value: true
    },
    {
      name: 'groups',
      title: 'Nhóm sản phẩm',
      value: true
    },
    {
      name: 'cumulativePoint',
      title: 'Điểm lũy kế',
      value: false
    },
    {
      name: 'status',
      title: 'Trạng thái',
      value: true
    },
    {
      name: 'appointment',
      title: 'Lịch hẹn',
      value: true
    },
    // {
    //   name: 'description',
    //   title: 'Ghi chú',
    //   value: false
    // },
    {
      name: 'historyOrder',
      title: 'Lịch sử mua hàng',
      value: true
    },
    {
      name: 'schoolLevelsName',
      title: 'Nhóm ngành',
      value: false
    },
    {
      name: 'typeName',
      title: 'Loại hình',
      value: false
    },
    {
      name: 'schoolName',
      title: 'Trường học',
      value: false
    },
    {
      name: 'activeCode',
      title: 'Mã kích hoạt',
      value: false
    },
  ];

  let storedData = localStorage.getItem('displayColumnsInContact')
  let rowAttributesNotIn = [];
  if(TokenService.getPosition() === userPositions.TELESALES) {
    rowAttributesNotIn = ['contactSources'];
  }
  if(TokenService.getPosition() === userPositions.STAFF) {
    rowAttributesNotIn.push('code')
  }
  if(storedData) {
    storedData = JSON.parse(storedData);
    let storedDataReturn = [];
    if(storedData && storedData.length){
      let isExist = {
        numberOfCall: false
      }
      for(let j = 0; j < resultOrg.length; j++){
        let item = resultOrg[j];
        for(let i = 0; i < storedData.length; i++){
          if(storedData[i].name == item.name){
            item.value = storedData[i].value;
          }
        }
        storedDataReturn.push(item);
      }
    }
    storedDataReturn = storedDataReturn.filter(item => !rowAttributesNotIn.includes(item.name));
    return storedDataReturn;
  }
  let resultOrgClone = resultOrg.filter(item => !rowAttributesNotIn.includes(item.name));
  return resultOrgClone;
  // return resultOrg;
}
